/** Read renewal fields from committee list API items (root or nested under `application`). */
export function pickCommitteeRenewalFields(item: Record<string, unknown>): {
	renewalType?: string;
	applicationType?: string;
} {
	const application = item.application as Record<string, unknown> | undefined;

	const renewalRaw =
		(typeof item.renewalType === "string" ? item.renewalType : undefined) ??
		(typeof application?.renewalType === "string" ? application.renewalType : undefined);

	const applicationTypeRaw =
		(typeof item.applicationType === "string" ? item.applicationType : undefined) ??
		(typeof application?.applicationType === "string" ? application.applicationType : undefined);

	return {
		renewalType: renewalRaw?.trim() || undefined,
		applicationType: applicationTypeRaw?.trim() || undefined,
	};
}
